import { SearchOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { columnTitles } from './column-titles.constant';
import '../style.scss';

export const columnsDefinition = [
	{
		title: columnTitles[Enviroment.LANGUAGE]?.brand,
		dataIndex: 'brand',
		className: 'own-column-one',
	},
	{
		title: columnTitles[Enviroment.LANGUAGE]?.code_local,
		render: (_, record) => `${record.pharmacy} - ${record.code_local}`,
		className: 'own-column-two',
	},
	{
		title: columnTitles[Enviroment.LANGUAGE]?.name_local,
		dataIndex: 'name_local',
		className: 'own-column-three',
	},
	{
		title: columnTitles[Enviroment.LANGUAGE]?.direction,
		dataIndex: 'direction',
		className: 'own-column-four',
		render: (_, record) => `${record.direction}, ${record.commune}, ${record.region}`,
	},
	{
		title: columnTitles[Enviroment.LANGUAGE]?.detail,
		render: (_, record) => (
			<Link to={`../pharmacy-locals/detail/${record._id}`}>
				<SearchOutlined />
			</Link>
		),
		className: 'own-column-five',
	},
];
